import { EventName } from '../offline-events';

export interface BadDate {
  id?: number;
  eventName: EventName;
  date: string; // YYYY-MM-DD in business timezone
}

export const exampleBadDate: BadDate = {
  id: 1,
  eventName: EventName.Search,
  date: '2020-07-01',
};
